import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageHeader } from 'src/components/common/page-header';
import { WttpQuestionList } from 'src/components/wttp/questions/list/list';
import { Routes } from 'src/components/common/router/constants';
import { Can } from 'src/utils/can';
import { UnauthorizedPage } from 'src/components/common/unauthorized';
import { Actions, AppArea, Subjects } from 'src/graphql/generated/graphql';

export const ManageQuestions = () => {
  const { t } = useTranslation();
  const breadCrumbsProps = {
    items: [
      {
        label: t('wttp.wttp-configuration'),
        url: Routes.wttpConfiguration.path,
      },
      { label: t('wttp.manage-questions.title') },
    ],
  };
  const title = t('wttp.manage-questions.title');

  return (
    <>
      <PageHeader title={title} breadcrumbs={breadCrumbsProps} />
      <Can I={Actions.Read} a={Subjects.Questions} appArea={AppArea.Wttp}>
        <WttpQuestionList />
      </Can>
      <Can not I={Actions.Read} a={Subjects.Questions} appArea={AppArea.Wttp}>
        <UnauthorizedPage />
      </Can>
    </>
  );
};

export default ManageQuestions;
